package org.zq.astrock_ai.platform

import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLTextAreaElement

actual object ClipboardHelper {
    actual fun copyText(text: String): Boolean {
        if (text.isEmpty()) return false
        // 1) 异步 Clipboard API（权限/非安全上下文可能失败，仍先尝试）
        val apiOk = runCatching {
            val nav = window.navigator.asDynamic()
            val clipboard = nav.clipboard
            if (clipboard != null) {
                clipboard.writeText(text)
                true
            } else {
                false
            }
        }.getOrDefault(false)
        if (apiOk) return true
        // 2) 同步兜底：临时 textarea + execCommand，兼容手机 Safari / 桌面 HTTP
        return runCatching {
            val ta = document.createElement("textarea") as HTMLTextAreaElement
            ta.value = text
            ta.setAttribute("readonly", "")
            ta.style.position = "fixed"
            ta.style.top = "0"
            ta.style.left = "0"
            ta.style.width = "1px"
            ta.style.height = "1px"
            ta.style.padding = "0"
            ta.style.border = "none"
            ta.style.outline = "none"
            ta.style.boxShadow = "none"
            ta.style.background = "transparent"
            document.body?.appendChild(ta)
            ta.focus()
            ta.select()
            ta.setSelectionRange(0, text.length)
            val ok = document.execCommand("copy")
            document.body?.removeChild(ta)
            ok
        }.getOrDefault(false)
    }
}
